<template>
  <Button
    label="Start&nbsp;Building"
    icon="pi pi-play"
    class="px-6 py-2 md:px-8 md:py-4 text-xl md:text-2xl"
    @click="openApp"
  />
</template>
<script setup lang="ts">
import Button from 'primevue/button'

function openApp() {
  window.location.href = window.__APP_CONFIG__.APP_START_URL
}
</script>
